import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { get } from 'lodash-es';
import { AliasResolverService } from 'src/app/shared/services/alias-resolver.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  private key = 'PCTOKEN';

  get authorization(): string {
    return `${this.getToken('token_type')} ${this.getToken('access_token')}`;
  }

  constructor(
    private router: Router,
    private aliasResolverService: AliasResolverService,
  ) {}

  hasToken(): boolean {
    return !!this.getToken();
  }

  getToken(...value: Array<string>): any {
    let token: any;

    try {
      const item = sessionStorage.getItem(this.key);
      token = item ? JSON.parse(item) : null;
    } catch (error) {}

    if (value.length > 0) {
      value.forEach((key) => {
        token = get(token, key, null);
      });
    }
    return token;
  }

  setToken(value: any): void {
    sessionStorage.setItem(this.key, JSON.stringify(value));
  }

  addValue(key: string, value: any): void {
    const token = this.getToken();
    token[key] = value;
    this.setToken(token);
  }

  removeTokenAndLogout(): void {
    const alias = ((this.getToken()?.['alias'] as string) || '').trim().toLowerCase();
    const [, suffix] = alias.split(/\s+/, 2);
    const hasAliasInSubdomain = !!this.aliasResolverService.extractAliasFromSubdomain();

    const loginRoute = hasAliasInSubdomain
      ? suffix
        ? `/login/${suffix}`
        : '/login'
      : alias
        ? `/login/${alias}`
        : '/login';

    sessionStorage.removeItem(this.key);

    if (!this.router.url.includes('login')) {
      this.router.navigate([loginRoute]);
    }
  }

  removeToken(): void {
    sessionStorage.removeItem(this.key);
  }
}
